export default {
  store: {
    system: '储能系统',
    detail:
      '储能系统可削峰填谷，平抑新能源波动，稳固电网运行，节能降本且绿色低碳。',
  },
  datacenter: {
    name: `数据中心`,
    detail: `算力集中高效，运维智能稳定，算力供给充足，支撑各类数字化业务运转`,
  },
  charger: {
    name: '充电桩',
    detail: '充电高效便捷，适配多车型，布局灵活，助力新能源汽车普及出行',
  },
  Photovoltaic: {
    name: '光伏',
    detail: '取之不尽无污染，适配多场景，发电稳定，有效减少传统能源消耗',
  },
  windpower_list: {
    name: '风电',
    detail: '绿色低碳无污染，发电效益持久，充分利用自然风能，赋能能源转型',
  },

  productItem: {
    name: '集装箱式储能一体机',
    t0: '智能高效',
    t1: '安全可靠',
    t2: '简单便捷',
    detail1: `ST10030kWh集装箱式储能一体机是将IES系列1000V三电平PCS、开关柜和升压变压器进行了优化集成，具有集成度高、单机功率大、内部结构紧凑、占地面积较小、应用简单、安装灵活等优点，可选择10kV/35kV电压等级配置直接接入电网，减少了复杂的高压系统设计工作、现场交流配电接线工作、系统间联调时间，大大的缩短了电站的建设周期，降低系统设计成本。`,

    detail2: `ST10030kWh系列直流1500V撬装式储能升压一体机，集成三台IES900系列直流1500V单机功率1725kW储能变流器，功率覆盖2.5MW~3.45MW。升压变压器可选油变或干变，高压柜兼容框架式高压柜与独立环网柜，配置可选负荷开关+ 熔断器或断路器，应用更灵活。`,

    detail3: `ST5015kWh-2500kW-MV-2h系列直流1500V撬装式储能升压一体机，集成两台IES900系列直流1500V单机功率1725kW储能变流器，功率覆盖2.5MW~3.45MW。升压变压器可选油变或干变，高压柜兼容框架式高压柜与独立环网柜，配置可选负荷开关+ 熔断器或断路器，应用更灵活。`,

    detail4: `ST5015kWh-2500kW-MV-2h系列直流1500V撬装式储能升压一体机，集成四台IES900系列直流1500V单机功率1725kW储能变流器，功率覆盖2.5MW~3.45MW。升压变压器可选油变或干变，高压柜兼容框架式高压柜与独立环网柜，配置可选负荷开关+`,
  },

  datacenter: {
    name: '模块化数据中心:Modular Data Center',
    name0: '绿色、节能、稳定、高效',
    t0: '智能高效',
    t1: '安全可靠',
    t2: '简单便捷',

    dt0: `本数据中心算力充沛、运行稳定，机柜布局规整，配套专业供配电与制冷系统。可实现数据安全、高效、可靠地存储与传输，具备出色的扩展能力，能够满足各类业务需求，为能源及科技领域筑牢数字化基础设施底座。`,
    dt1: `数据中心配备标准化机柜及全套配套设施，可全天候稳定运行。具备高效数据处理、安全存储与快速传输能力，能耗低、扩展性强，为数字化业务运营提供可靠保障。`,
    dt2: `高标准建设的数据中心，布局合理、设施齐全。具备强大的数据运算、存储与传输能力，运行安全稳定、节能环保。同时支持灵活扩容，全方位满足不同行业数字化需求，是可靠的算力与数据服务支撑平台。`,
  },

  charging: {
    name: '充电桩 / 充电终端：Charging Pile / Charging Terminal',
    name0: '绿色、节能、稳定、高效',
    t0: '智能高效',
    t1: '安全可靠',
    t2: '简单便捷',

    dt0: `本产品采用紧凑化结构设计，设备搭载热管散热技术并配备整机独立大风扇，优化内部风道结构，散热性能优异；采用IGBT
          多管并联方案，支持功率模块灵活配置，大幅提升功率密度。
          创新转子上进线结构，适配塔基安装方案，减少转子电缆用量。同时设备环境适配能力出色，可在高低温、高海拔、高湿热等复杂工况下长期稳定运行。`,
    dt1: `出厂100%满载测试，多重质量保障高品质器件选型，设备更可靠,整机IP55防护，适用各种严苛环境`,
    dt2: `采用 “1+X” 可扩展架构，主机功率可在 1MW-2.88MW 区间升级，终端最大支持 3000A；设备具备 150-1000V 超宽电压范围，可全面适配各类车型。同时提供光储充一站式解决方案，有效缓解电网冲击、提升绿电收益，结合快充与超充模式灵活组合，充分满足不同场景的充电需求。`,
    dt3: `设备支持有序充电模式，有效提升整体运营效率。依托 AI 智能诊断与主动防护机制，全面强化充电安全。运维平台可实现 300 余项数据实时监测，全天候保障设备稳定运行。`,
  },

  photovoltaic_info: {
    name: '光伏板 / 太阳能板：photovoltaic',
    name0: '绿色、节能、稳定、高效',
    t0: '智能高效',
    t1: '安全可靠',
    t2: '简单便捷',

    dt0: `高效光伏太阳能板，捕捉自然光转化清洁电能。采用优质材质打造，光电转换率高，耐候抗老化，无惧风雨日晒。适配户用、工商业电站等多种场景，低碳节能、持久续航，助力降低用电成本，以绿色能源赋能可持续发展。`,
    dt1: `一块太阳能板，解锁绿色用电新生活。高效吸能发电，安装便捷、运行静音，日晒即可稳定供电。坚固耐用寿命长久，日常用电自给自足，大幅节省电费。践行低碳环保，用自然光能，守护家园与美好生态。`,
    dt2: `汲取阳光能量，缔造绿色电力。高品质光伏板工艺精湛，发电稳定、性能出众。依托先进技术提升转化效率，适应各类户外环境。零污染、低能耗，深耕清洁能源领域，携手大众共建低碳未来，让阳光创造无限价值。`,
    dt3: `拥抱阳光，畅享绿电！高性能太阳能光伏板，光电转化强劲，抗风耐腐经久耐用。灵活适配多种安装场景，自发自用经济实惠。告别高能耗，践行绿色理念，把无尽日光化作源源电力，开启环保节能新方式。`,
  },

  windpower: {
    name: '风电：Wind Power',
    name0: '绿色、节能、稳定、高效',
    t0: '智能高效',
    t1: '安全可靠',
    t2: '简单便捷',

    dt0: `高效风电设备，捕捉自然风能转化清洁电能。采用优质工业材质打造，风能转化率高，耐候抗磨损，无惧狂风沙尘、严寒酷暑。适配户用、工商业、分布式电站等多种场景，低碳节能、稳定续航，助力降低用电成本，以绿色风电赋能可持续发展。`,
    dt1: `一台风力发电机组，解锁绿色用电新生活。高效捕风发电，安装便捷、运行静音低耗，有风即可稳定供电。坚固耐用使用寿命长久，日常用电自给自足，大幅节省用电开支。践行低碳环保理念，利用自然风力资源，守护生态家园与绿色环境。`,
    dt2: `汲取自然风力，缔造纯净绿电。高品质风电设备工艺精湛，发电稳定、性能出众。依托先进风电技术提升能量转化效率，适配各类户外复杂工况。零污染、低能耗，深耕清洁能源领域，携手大众共建零碳未来，让清风创造无限能源价值。`,
    dt3: `拥抱清风，畅享绿电！高性能风力发电设备，风能转化强劲，抗风耐腐、经久耐用。灵活适配山地、平原、厂区等多种安装场景，自发自用、经济实惠。告别传统高能耗模式，践行绿色低碳理念，把无尽风力化作源源电力，开启节能环保全新用电方式。`,
  },
  menuList: [
    { name: '数据中心' },
    {
      name: '储能',
      // children: [{ name: '工商业储能' }, { name: '电力储能' }],
    },
    {
      name: '充电设备',
      // children: [{ name: '电动汽车充电设备' }, { name: '电动车充电设备' }],
    },
    { name: '光伏' },
    { name: '变压器' },
    { name: '风电' },
  ],
};
